import { useEffect, useRef } from 'react';

import { useAuth } from '@xemplo/auth-provider';
import { safeCallAsync } from '@xemplo/safe-call';

export function SilentRenew() {
  const { signinSilentCallback } = useAuth();

  const silentRenewRef = useRef(false);

  useEffect(() => {
    if (silentRenewRef.current) return;

    silentRenewRef.current = true;
    safeCallAsync(signinSilentCallback());
  }, [signinSilentCallback]);

  return null; // Silent renew does not need to render anything
}
